export default "__VITE_ASSET__CDnNOS3o__"